module.exports = __webpack_public_path__ + "img/pg4-article-text3.8919a890.png";